// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"329":"2037eeef24e80cb62db1","635":"a939b234d84d1bd67919"}[chunkId] + ".js";
};